import logo from "../assets/img/logo/logo.svg";
import w_logo from "../assets/img/logo/w_logo.svg";
import h2_footer_bg from "../assets/img/bg/h2_footer_bg.jpg";
import h3_banner_img01 from "../assets/img/banner/h3_banner_img01.jpg";
import h3_banner_img02 from "../assets/img/banner/h3_banner_img02.jpg";
import h3_banner_shape01 from "../assets/img/banner/h3_banner_shape01.png";
import h3_banner_shape02 from "../assets/img/banner/h3_banner_shape02.png";
import h3_about_img01 from "../assets/img/images/h3_about_img01.jpg";
import h3_about_img02 from "../assets/img/images/h3_about_img02.jpg";
import h3_about_shape01 from "../assets/img/images/h3_about_shape01.png";
import h3_about_shape02 from "../assets/img/images/h3_about_shape02.png";
import h3_about_shape03 from "../assets/img/images/h3_about_shape03.png";
import h3_testimonial_img from "../assets/img/images/h3_testimonial_img.jpg";
import h4_about_img01 from "../assets/img/images/h4_about_img01.jpg";
import h4_about_img02 from "../assets/img/images/h4_about_img02.png";
import h4_about_shape from "../assets/img/images/h4_about_shape.png";
import h3_overview_img01 from "../assets/img/images/h3_overview_img01.jpg";
import h3_overview_img02 from "../assets/img/images/h3_overview_img02.jpg";
import h3_overview_shape01 from "../assets/img/images/h3_overview_shape01.png";
import h3_overview_shape02 from "../assets/img/images/h3_overview_shape02.png";
import h2_request_shape01 from "../assets/img/images/h2_request_shape01.png";
import h2_request_shape02 from "../assets/img/images/h2_request_shape02.png";
import brand_img01 from "../assets/img/brand/brand_img01.png";
import brand_img02 from "../assets/img/brand/brand_img02.png";
import brand_img03 from "../assets/img/brand/brand_img03.png";
import brand_img04 from "../assets/img/brand/brand_img04.png";
import brand_img05 from "../assets/img/brand/brand_img05.png";
import check_icon from "../assets/img/icons/check_icon.svg";
import check_icon02 from "../assets/img/icons/check_icon02.svg";
import check_icon03 from "../assets/img/icons/check_icon03.svg";
import right_arrow from "../assets/img/icons/right-arrow.svg";
import quote02 from "../assets/img/icons/quote02.svg";
import quote from "../assets/img/icons/quote.svg";
import plus_icon from "../assets/img/icons/plus_icon.svg";
import rating from "../assets/img/icons/rating.svg";
import blog_avatar01 from "../assets/img/blog/antonio_40x40.png";
import breadcrumb_shape01 from "../assets/img/images/breadcrumb_shape01.png";
import breadcrumb_shape02 from "../assets/img/images/breadcrumb_shape02.png";
import inner_features_shape from "../assets/img/images/inner_features_shape.png";
import share from "../assets/img/icons/share.svg";
import rc_post01 from "../assets/img/blog/blog_01_rc_76x75.jpg";
import contact_img from "../assets/img/images/contact_img_600x579.jpg";
import comercio_exterior_show_image_320x240 from "../assets/img/services/comercio_exterior_show_image_320x240.jpg";
import customs_clearance_show_image_320x240 from "../assets/img/services/customs_support_showcase_image_320x240.jpg";
import import_export_show_image_320x240 from "../assets/img/services/impo_expo_showcase_img_320x240.jpg";
import international_logistics_show_image_320x240 from "../assets/img/services/international_logistics_320x240.jpg";
import blog_01_showcase_image_392x260 from "../assets/img/blog/blog_01_showcase_image_392x260.jpg";
import blog_01_main_image_857x480 from "../assets/img/blog/blog_01_main_857x480.jpg";
import blog_01_img_02_857x480 from "../assets/img/blog/blog_01_img_02_857x480.png";
import blog_01_img_03_857x480 from "../assets/img/blog/blog_01_img_03_857x480.png";
import blog_01_img_04_857x480 from "../assets/img/blog/blog_01_img_04_857x480.png";
import blog_02_showcase_image_392x260 from "../assets/img/blog/blog_02_showcase_image_392x260.jpg";
import blog_02_main_image_857x480 from "../assets/img/blog/blog_02_main_857x480.jpg";
import blog_02_img_02_857x480 from "../assets/img/blog/blog_02_img_02_857x480.png";
import blog_02_img_03_857x480 from "../assets/img/blog/blog_02_img_03_857x480.png";
import blog_02_img_04_857x480 from "../assets/img/blog/blog_02_img_04_857x480.png";
import comercio_exterior_service_main_457x380 from "../assets/img/services/comercio_exterior_service_main_457x380.jpg";
import customs_support_showcase_image_457x380 from "../assets/img/services/customs_support_showcase_image_457x380.jpg";
import import_export_main_img_457x380 from "../assets/img/services/impo_expo_main_img_457x380.jpg";
import international_logistics_main_img_457x380 from "../assets/img/services/international_logistics_main_img_457x380.jpg";
import h2_team_img01 from "../assets/img/team/h2_team_img01.png";
import h2_team_img02 from "../assets/img/team/h2_team_img02.png";
import h2_team_img03 from "../assets/img/team/h2_team_img03.png";
import h2_team_img04 from "../assets/img/team/h2_team_img04.png";


// logo
export const LOGO = logo;
export const W_LOGO = w_logo;

// bg
export const H2_FOOTER_BG = h2_footer_bg;

// banner
export const H3_BANNER_IMG01 = h3_banner_img01;
export const H3_BANNER_IMG02 = h3_banner_img02;
export const H3_BANNER_SHAPE01 = h3_banner_shape01;
export const H3_BANNER_SHAPE02 = h3_banner_shape02;

// images
export const H3_TESTIMONIAL_IMG = h3_testimonial_img;
export const H2_REQUEST_SHAPE01 = h2_request_shape01;
export const H2_REQUEST_SHAPE02 = h2_request_shape02;
export const H3_ABOUT_IMG01 = h3_about_img01;
export const H3_ABOUT_IMG02 = h3_about_img02;
export const H3_ABOUT_SHAPE01 = h3_about_shape01;
export const H3_ABOUT_SHAPE02 = h3_about_shape02;
export const H3_ABOUT_SHAPE03 = h3_about_shape03;
export const H4_ABOUT_IMG01 = h4_about_img01;
export const H4_ABOUT_IMG02 = h4_about_img02;
export const H4_ABOUT_SHAPE = h4_about_shape;
export const H3_OVERVIEW_IMG01 = h3_overview_img01;
export const H3_OVERVIEW_IMG02 = h3_overview_img02;
export const H3_OVERVIEW_SHAPE01 = h3_overview_shape01;
export const H3_OVERVIEW_SHAPE02 = h3_overview_shape02;
export const BREADCRUMB_SHAPE01 = breadcrumb_shape01;
export const BREADCRUMB_SHAPE02 = breadcrumb_shape02;
export const INNER_FEATURES_SHAPE = inner_features_shape;
export const CONTACT_IMG = contact_img;
export const COMERCIO_EXTERIOR_SHOW_IMAGE_320X240 = comercio_exterior_show_image_320x240;
export const CUSTOMS_CLEARANCE_SHOW_IMAGE_320X240 = customs_clearance_show_image_320x240;
export const IMPORT_EXPORT_SHOW_IMAGE_320X240 = import_export_show_image_320x240;
export const INTERNATIONAL_LOGISTICS_SHOW_IMAGE_320X240 = international_logistics_show_image_320x240;

// brand
export const BRAND_IMG01 = brand_img01;
export const BRAND_IMG02 = brand_img02;
export const BRAND_IMG03 = brand_img03;
export const BRAND_IMG04 = brand_img04;
export const BRAND_IMG05 = brand_img05;

// services
export const COMERCIO_EXTERIOR_SERVICE_MAIN_457X380 = comercio_exterior_service_main_457x380;
export const CUSTOMS_SUPPORT_SHOWCASE_IMAGE_457X380 = customs_support_showcase_image_457x380;
export const IMPORT_EXPORT_MAIN_IMG_457X380 = import_export_main_img_457x380;
export const INTERNATIONAL_LOGISTICS_MAIN_IMG_457X380 = international_logistics_main_img_457x380;

// project

// team

// icons
export const CHECK_ICON = check_icon;
export const CHECK_ICON02 = check_icon02;
export const CHECK_ICON03 = check_icon03;
export const RIGHT_ARROW = right_arrow;
export const QUOTE02 = quote02;
export const QUOTE = quote;
export const PLUS_ICON = plus_icon;
export const RATING = rating;
export const SHARE = share;

// blogs
export const BLOG_AVATAR01 = blog_avatar01;
export const RC_POST01 = rc_post01;
export const BLOG_01_SHOWCASE_IMAGE_392X260 = blog_01_showcase_image_392x260;
export const BLOG_01_MAIN_IMAGE_857X480 = blog_01_main_image_857x480;
export const BLOG_01_IMG_02_857X480 = blog_01_img_02_857x480;
export const BLOG_01_IMG_03_857X480 = blog_01_img_03_857x480;
export const BLOG_01_IMG_04_857X480 = blog_01_img_04_857x480;
export const BLOG_02_SHOWCASE_IMAGE_392X260 = blog_02_showcase_image_392x260;
export const BLOG_02_MAIN_IMAGE_857X480 = blog_02_main_image_857x480;
export const BLOG_02_IMG_02_857X480 = blog_02_img_02_857x480;
export const BLOG_02_IMG_03_857X480 = blog_02_img_03_857x480;
export const BLOG_02_IMG_04_857X480 = blog_02_img_04_857x480;

// team
export const H2_TEAM_IMG01 = h2_team_img01;
export const H2_TEAM_IMG02 = h2_team_img02;
export const H2_TEAM_IMG03 = h2_team_img03;
export const H2_TEAM_IMG04 = h2_team_img04;
